let Settings = {
  apiBaseUrl: '/api',
  apiUserUrl: '/api/user',
  apiBlogsUrl: '/api/blogs',
  apiQuestionsUrl: '/api/questions',
  enumTypes: '/api/enum',
  apiZakkatUrl: '/api/zakkat',
  enumTypesForStatus: [{ label: 'Approved', value: 1 }, { label: 'Pending', value: 2 }, { label: "Rejected", value: 3 }],
  enumDonationType: [{ label: 'I Would Like to Receive Meat', value: 1 }, { label: 'Share Meat with Those in Need', value: 2 }],
  enumQurbaniCategories: [{ label: 'Category A', value: 1 }, { label: 'Category B', value: 2 }]
};

export default Settings;